var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatErrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 6,
    viewBox: "0 0 17 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9885 5.09104C16.9885 1.80913 13.558 -0.344413 10.6023 1.08197L4.13921 4.2009C2.92517 4.78676 1.59456 5.09104 0.246545 5.09104L0.496879 5.09092C0.500007 5 -0.196391 5.09104 0.496879 5.09092C0.496879 5.09092 0.36755 5.09098 0.246545 5.09104L0.488458 5.09092C0.488458 5.09092 2.48845 5.09104 2.98845 5.09104C3.48845 5.09104 6.98845 5.09104 6.98845 5.09104C7.48845 5.09104 16.9885 5.09104 16.9885 5.09104Z",
    fill: "#442A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatErrow);
export default __webpack_public_path__ + "static/media/chat-errow.e0085e7fc303df9843d0db343a42fe5d.svg";
export { ForwardRef as ReactComponent };